import React, { useState, useRef } from "react";
import AxiosInstance from "../../utils/axiosInstance";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const StepButton = ({ step, onComplete, disabled, loading }) => (
  <button
    onClick={() => !disabled && !loading && onComplete(step.step_order)}
    disabled={disabled || loading || step.status === "1"}
    className={`btn btn-${step.status === "1" ? "success" : "primary"} w-100 ${
      disabled || loading ? "opacity-50 cursor-not-allowed" : ""
    }`}
  >
    {loading ? (
      <>
        <span className="spinner-border spinner-border-sm mr-2" role="status" />
        Processing...
      </>
    ) : (
      <>
        {step.step_name} {step.status === "1" && "(Complete)"}
      </>
    )}
  </button>
);

const CronJobSteps = ({ initialSteps = [], doc_type = "AL", setApiCall }) => {
 
  const [steps, setSteps] = useState(initialSteps);
  const [loadingStepId, setLoadingStepId] = useState(null);
  const abortControllerRef = useRef(null);
  const navigate =useNavigate() ;
  const handleCompleteStep = (stepId) => {

 
    if (stepId == 1) {
        const userConfirmed = window.confirm("Upload new file from dashboard");
        if (userConfirmed) {
            navigate('/ccn'); // Proceed if user clicks OK
        }
        return;
    }
    
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    setLoadingStepId(stepId); // Start loading

    const controller = new AbortController();
    abortControllerRef.current = controller;

    const queryParams = new URLSearchParams({
      doc_type,
      step: stepId,
    });

    const currentTime = new Date().getTime();

    AxiosInstance.post(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_POST_ACTION_ON_TEMP_DATA}`,
      queryParams,
      { signal: controller.signal }
    )
      .then((response) => {
        if (response.data?.status) {
          toast.success(response.data?.message);
          setApiCall(true);
        } else {
          toast.success(response.data?.message);
        }

        setSteps((prevSteps) => {
            // Find the index of the selected step
            const currentIndex = prevSteps.findIndex((step) => step.step_order === stepId);
          
            // Update all steps up to and including the current one
            return prevSteps.map((step, index) => {
              if (index <= currentIndex) {
                return { ...step, status: "1" }; // mark as completed/disabled
              }
              return step; // leave others unchanged
            });
          });
          
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
            toast.error(error?.message)
        }
        
      })
      .finally(() => {
        setLoadingStepId(null); // Stop loading
      });
  };

  const isStepDisabled = (order) => {
    if (parseInt(order) === 1) return false;
    const prevStep = steps.find(
      (s) => parseInt(s.step_order) === parseInt(order) - 1
    );
    return !(prevStep && prevStep.status === "1");
  };

  return (
    <div className="row px-4">
     
      {steps.map((step) => (
        <div
          key={step.id}
          className="col-md-2 mb-3 d-flex justify-content-center"
        >
          <StepButton
            step={step}
            onComplete={handleCompleteStep}
            disabled={isStepDisabled(step.step_order)}
            loading={loadingStepId === step.step_order}
          />
        </div>
      ))}
    </div>
  );
};

export default CronJobSteps;
